export const requestStatus = {
  submitted: "Submitted",
  approved: "Approved",
  preApproved: "PreApproved",
  rejected: "Rejected",
  inProgress: "c",
  acceptance: "Acceptance",
  completed: "Completed",
  canceled: "canceled",
  draft: "draft",
  revoked: "Revoked",
};

export const requestStatusOptions = [
  {
    label: "Đang đợi duyệt",
    value: "Submitted",
  },
  {
    label: "Đã duyệt",
    value: "Approved",
  },
  {
    label: "Đang đợi duyệt",
    value: "PreApproved",
  },
  {
    label: "Đã bị từ chối",
    value: "Rejected",
  },
  {
    label: "Đang thực thi",
    value: "c",
  },
  {
    label: "Đã tiếp nhận",
    value: "Completed",
  },
];

export const courseStatus = {
  waitingreview: "WaitingForReview",
  reviewed: "Reviewed",
  waitingapproval: "WaitingForApproval",
  approved: "Approved",
  rejected: "Rejected",
  open: "Open",
  close: "Close",
};

export const documentStatus = {
  new: { id: 1, value: "new", label: "Khởi tạo" },
  compose: { id: 2, value: "compose", label: "Soạn thảo" },
  feedback: { id: 3, value: "feedback", label: "Lấy ý kiến" },
  review: { id: 4, value: "review", label: "Soát xét" },
  check: { id: 9, value: "check", label: "Kiểm tra" },
  interimpublish: {
    id: 5,
    value: "interimpublish",
    label: "Ban hành tạm thời",
  },
  approval: { id: 6, value: "approval", label: "Chờ phê duyệt" },
  readytopublish: { id: 7, value: "readytopublish", label: "Phê duyệt" },
  publish: { id: 8, value: "publish", label: "Ban hành" },
  needProcess: { id: 11, value: "needprocess", label: "Cần xử lý" },
  tags: { id: 12, value: "tags", label: "Tài liệu theo chủ đề" },
  reject: { id: 1000, value: "reject", label: "Từ chối" },
  template: { id: 100, value: "template", label: "Quản lí template" },
};

export const documentInfoStatus = {
  new: { id: 1, value: "new", label: "Khởi tạo" },
  compose: { id: 2, value: "compose", label: "Soạn thảo" },
  feedback: { id: 3, value: "feedback", label: "Lấy ý kiến" },
  review: { id: 4, value: "review", label: "Soát xét" },
  interimpublish: {
    id: 5,
    value: "interimpublish",
    label: "Ban hành tạm thời",
  },
  approval: { id: 6, value: "approval", label: "Chờ phê duyệt" },
  readytopublish: {
    id: 7,
    value: "readytopublish",
    label: "Sẵn sàng để ban hành",
  },
  publish: { id: 8, value: "publish", label: "Ban hành" },
};

export const composeStatus = {
  compose: { id: 2, value: "compose", label: "Soạn thảo" },
};

export const userAction = {
  info: "info",
  process: "process",
  edit: "edit",
  new: "new",
  file: "file",
  comment: "comment",
};

export const docTypes = [
  { value: "internal", label: "Nội bộ" },
  { value: "external", label: "Bên ngoài" },
  { value: "suboffice", label: "Chi nhánh" },
  { value: "others", label: "Khác" },
];

export const checkLoggingStatus = {
  InteractionNotCompleted: "InteractionNotCompleted",
  NotLoggedIn: "NotLoggedIn",
  ExpiredToken: "ExpiredToken",
  Unauthorized: "Unauthorized",
  OK: "OK",
};
